var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocaliztion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM7.2 14.344C4.04 13.952 1.6 11.264 1.6 8C1.6 7.504 1.664 7.032 1.768 6.568L5.6 10.4L5.6 11.2C5.6 12.08 6.32 12.8 7.2 12.8V14.344ZM12.72 12.312C12.512 11.664 11.92 11.2 11.2 11.2H10.4V8.8C10.4 8.36 10.04 8 9.6 8L4.8 8V6.4H6.4C6.84 6.4 7.2 6.04 7.2 5.6V4H8.8C9.68 4 10.4 3.28 10.4 2.4V2.072C12.744 3.024 14.4 5.32 14.4 8C14.4 9.664 13.76 11.176 12.72 12.312Z",
    fill: "#82858B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaliztion);
export default __webpack_public_path__ + "static/media/localiztion.61f88a83c8a1546b85bbdd1e5bcfc42a.svg";
export { ForwardRef as ReactComponent };